<!--Translated-->
<template>
  <tbody>
    <template v-for="(item, index) in displayItems">
      <tr
        class="row"
        v-if="item.type === 'product'"
        :class="{ 'tbl_row--active': getSelectedState(item.data) }"
        :key="item.data.id"
      >
        <td
          class="tbl-cellproblem"
          v-if="index === 0"
          :rowspan="totalRowsCount"
        >
          <div :class="phase.is_temporary ? 'cellproblem-inner' : ''">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: 'info' }"></div>
                <HoverTooltip :header="sType.name" :text="sType.description" />
              </div>
              <div class="tbl_info-celltext">{{ sType.name }}</div>
            </div>
            <Button
              v-if="phase.is_temporary && products.length >= 2 && canEdit"
              :text="$t('DefenseCombinations:Button')"
              size="h-micro"
              color="accentlines"
              icon="plus"
              @click="addCombination"
            />
          </div>
        </td>

        <td class="tbl-cellproduct" colspan="2">
          <div class="tbl_info">
            <div class="tbl_info-wrap" style="display: flex">
              <div v-if="!phase.is_temporary" class="tbl_checkboxproduct">
                <CheckBox
                  color-checked="accentfill"
                  color-un-checked="gray"
                  @input="onChange(item.data)"
                  :value="getSelectedState(item.data)"
                  :style="{ pointerEvents: canEdit ? '' : 'none' }"
                />
              </div>
              <div
                v-else-if="item.data.is_active"
                v-svg="{ name: 'info' }"
              ></div>
              <div
                id="force-red"
                v-if="!item.data.is_active"
                v-svg="{ name: 'warningtriangle' }"
              />
              <HoverTooltipProduct :product="item.data" />
            </div>
            <div
              class="tbl_info-celltext"
              @click="!phase.is_temporary && onChange(item.data)"
              :style="calcProductNameStyle(item.data)"
            >
              {{ item.data.name }}
            </div>
          </div>
        </td>
        <td
          v-if="!phase.is_temporary && canEdit"
          class="tbl-cellinpt"
          @dblclick="startEditing(item.data)"
        >
          <div
            v-if="isEditing(item.data)"
            :ref="`editContainer_${item.data.id}`"
            class="quantity-editor"
          >
            <InputNumber
              :ref="`editInput_${item.data.id}`"
              class="inputintable quantity-editor__input"
              label="-"
              size="max"
              :value="editingValue"
              :state="isSaving ? 'disabled' : canEdit ? '' : 'disabled2'"
              @input="onEditInput"
              @keydown.enter.native.prevent="confirmEditing(item.data)"
              @keydown.esc.native.prevent="cancelEditing"
            />
            <button
              type="button"
              class="quantity-editor__submit"
              @mousedown.prevent
              @click.stop="confirmEditing(item.data)"
            >
              <div v-svg="{ name: 'tick' }"></div>
            </button>
          </div>
          <div
            v-else
            class="quantity-display"
            :class="{
              'quantity-display--override': hasQuantityOverride(item.data),
            }"
          >
            <span v-if="hasQuantityOverride(item.data)" class="quantity-old">
              <s>{{ getTemplateQuantity(item.data) }}</s>
            </span>
            <span class="quantity-current">{{
              productsAsMap[item.data.id]
            }}</span>
          </div>
        </td>
        <td class="tbl-cellprice" v-else-if="!phase.is_temporary || !canEdit">
          {{ productsAsMap[item.data.id] }}
        </td>
        <td v-else class="tbl-cellinpt">
          <InputNumber
            class="inputintable"
            label="-"
            :value="getTempProductDisplayValue(item.data)"
            @input="onInput(item.data, $event)"
            :state="getTempProductInputState(item.data)"
            :inptwrapClass="
              isTempProductPristine(item.data) ? 'temp-input--pristine' : ''
            "
            :disableCompletedClass="isTempProductPristine(item.data)"
          />
        </td>
        <td class="tbl-cellprice">
          {{
            item.data.picking
              ? (
                  (item.data.price / item.data.picking) *
                  getEffectiveQuantity(item.data)
                ).toFixed(2)
              : '0.00'
          }}
        </td>
        <td
          v-if="index === 0 && phase.is_temporary && canEdit"
          :rowspan="totalRowsCount"
          class="col-delete"
          @click="$emit('deleteStimulationType', sType.id)"
        >
          <div v-svg="{ name: 'delete' }"></div>
        </td>
      </tr>

      <!-- Combinations -->
      <template v-else-if="item.type === 'combination'">
        <template v-if="phase.is_temporary">
          <tr
            v-if="index > 0"
            class="row row--combination-spacer"
            :key="'combo-spacer-' + item.id"
          >
            <td colspan="5"></td>
          </tr>

          <tr
            class="row tbl_row--active row--combination"
            :key="'combo-header-' + item.id"
          >
            <th
              v-if="index === 0"
              class="tbl-cellproblem"
              :rowspan="totalRowsCount"
            >
              <div class="cellproblem-inner">
                <div class="tbl_info">
                  <div class="tbl_info-wrap">
                    <div v-svg="{ name: 'info' }"></div>
                    <HoverTooltip
                      :header="sType.name"
                      :text="sType.description"
                    />
                  </div>
                  <div class="tbl_info-celltext">{{ sType.name }}</div>
                </div>
                <Button
                  v-if="products.length >= 2 && canEdit"
                  :text="$t('DefenseCombinations:Button')"
                  size="h-micro"
                  color="accentlines"
                  icon="plus"
                  @click="addCombination"
                />
              </div>
            </th>
            <th class="combination-header-cell" colspan="4">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: 'combinationpuzzle' }"></div>
                  <AppInput
                    :value="item.comment"
                    @input="updateComboComment(item.id, $event)"
                    class="inputintable inputintable--comment"
                    type="text"
                    :placeholder="$t('DefenseCombinations:CommentPlaceholder')"
                  />
                </div>
                <div
                  v-if="canEdit"
                  class="combination-header-delete"
                  @click="removeCombination(item.id)"
                >
                  <div v-svg="{ name: 'delete' }"></div>
                </div>
              </div>
            </th>
          </tr>

          <tr
            v-for="(comboProd, cIdx) in item.products"
            :key="'combo-prod-' + item.id + '-' + comboProd._comboProductId"
            class="row tbl_row--active row--combination"
          >
            <td
              v-if="cIdx === 0"
              class="col-add"
              :rowspan="item.products.length"
              @click="openComboAddModal(item.id)"
            >
              <div v-svg="{ name: 'plus2' }"></div>
            </td>
            <td
              class="tbl-cellproduct"
              :class="{ 'tbl-cellproduct--grey': !comboProd.quantity }"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div
                    id="force-red"
                    v-if="!comboProd.is_active"
                    v-svg="{ name: 'warningtriangle' }"
                  />
                  <div v-else v-svg="{ name: 'info' }"></div>
                  <HoverTooltipProduct :product="comboProd" />
                </div>
                <div class="tbl_info-celltext">{{ comboProd.name }}</div>
                <div
                  class="combination-inline-delete"
                  @click="removeComboProduct(comboProd._comboProductId)"
                >
                  <div v-svg="{ name: 'delete' }"></div>
                </div>
              </div>
            </td>
            <td class="tbl-cellinpt">
              <InputNumber
                class="inputintable"
                label="-"
                :value="getTempComboProductDisplayValue(comboProd)"
                @input="onComboProductInput(comboProd._comboProductId, $event)"
                :state="getTempComboProductInputState(comboProd)"
                :inptwrapClass="
                  isTempComboProductPristine(comboProd)
                    ? 'temp-input--pristine'
                    : ''
                "
                :disableCompletedClass="isTempComboProductPristine(comboProd)"
              />
            </td>
            <td class="tbl-cellprice">
              {{
                comboProd.picking && comboProd.quantity
                  ? (
                      (comboProd.price / comboProd.picking) *
                      comboProd.quantity
                    ).toFixed(2)
                  : '0.00'
              }}
            </td>
          </tr>

          <tr
            v-if="item.products.length === 0"
            class="row tbl_row--active row--combination"
            :key="'combo-empty-' + item.id"
          >
            <td
              v-if="index === 0"
              class="tbl-cellproblem"
              :rowspan="totalRowsCount"
            >
              <div class="cellproblem-inner">
                <div class="tbl_info">
                  <div class="tbl_info-wrap">
                    <div v-svg="{ name: 'info' }"></div>
                    <HoverTooltip
                      :header="sType.name"
                      :text="sType.description"
                    />
                  </div>
                  <div class="tbl_info-celltext">{{ sType.name }}</div>
                </div>
                <Button
                  v-if="products.length >= 2 && canEdit"
                  :text="$t('DefenseCombinations:Button')"
                  size="h-micro"
                  color="accentlines"
                  icon="plus"
                  @click="addCombination"
                />
              </div>
            </td>
            <td
              class="col-add combination-col-add"
              @click="openComboAddModal(item.id)"
            >
              <div v-svg="{ name: 'plus2' }"></div>
            </td>
            <td
              class="tbl-cellproduct"
              colspan="4"
              style="text-align: center; color: #999"
            >
              {{ $t('DefenseCombinations:MinProducts') }}
            </td>
          </tr>
        </template>

        <template v-else>
          <tr
            v-for="(comboProd, cIdx) in item.products"
            :key="'combo-prod-' + item.id + '-' + comboProd._comboProductId"
            class="row row--combination"
            :class="{ 'tbl_row--active': item.is_selected }"
          >
            <td
              class="tbl-cellproblem"
              v-if="index === 0 && cIdx === 0"
              :rowspan="totalRowsCount"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: 'info' }"></div>
                  <HoverTooltip
                    :header="sType.name"
                    :text="sType.description"
                  />
                </div>
                <div class="tbl_info-celltext">{{ sType.name }}</div>
              </div>
            </td>

            <td
              class="col-add tbl-cellproduct"
              v-if="cIdx === 0"
              :rowspan="item.products.length"
              style="padding-left: 0"
            >
              <div class="tbl_info">
                <div
                  class="tbl_info-wrap tooltip-trigger"
                  style="
                    display: flex;
                    justify-content: center;
                    gap: 0;
                    position: relative;
                  "
                >
                  <div v-if="!phase.is_temporary" class="tbl_checkboxproduct">
                    <CheckBox
                      color-checked="accentfill"
                      color-un-checked="gray"
                      @input="onComboChange(item)"
                      :value="item.is_selected"
                      :style="{ pointerEvents: canEdit ? '' : 'none' }"
                    />
                  </div>
                  <HoverTooltip v-if="item.comment" :text="item.comment" />
                </div>
              </div>
            </td>

            <td class="tbl-cellproduct">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div
                    id="force-red"
                    v-if="!comboProd.is_active"
                    v-svg="{ name: 'warningtriangle' }"
                  />
                  <div
                    class="tbl_info-celltext"
                    :style="
                      calcProductNameStyle(comboProd, true, item.is_selected)
                    "
                  >
                    {{ comboProd.name }}
                  </div>
                  <HoverTooltipProduct :product="comboProd" />
                </div>
              </div>
            </td>

            <td
              v-if="!phase.is_temporary && canEdit"
              class="tbl-cellinpt"
              @dblclick="startEditingCombo(comboProd._comboProductId)"
            >
              <div
                v-if="isEditingCombo(comboProd._comboProductId)"
                :ref="`editContainer_combo_${comboProd._comboProductId}`"
                class="quantity-editor"
              >
                <InputNumber
                  :ref="`editInput_combo_${comboProd._comboProductId}`"
                  class="inputintable quantity-editor__input"
                  label="-"
                  size="max"
                  :value="editingValue"
                  :state="isSaving ? 'disabled' : ''"
                  @input="onEditInput"
                  @keydown.enter.native.prevent="
                    confirmComboEditing(comboProd._comboProductId)
                  "
                  @keydown.esc.native.prevent="cancelEditing"
                />
                <button
                  type="button"
                  class="quantity-editor__submit"
                  @mousedown.prevent
                  @click.stop="confirmComboEditing(comboProd._comboProductId)"
                >
                  <div v-svg="{ name: 'tick' }"></div>
                </button>
              </div>
              <div
                v-else
                class="quantity-display"
                :class="{
                  'quantity-display--override': hasComboQuantityOverride(
                    comboProd._comboProductId
                  ),
                }"
              >
                <span
                  v-if="hasComboQuantityOverride(comboProd._comboProductId)"
                  class="quantity-old"
                >
                  <s>{{
                    getComboTemplateQuantity(comboProd._comboProductId)
                  }}</s>
                </span>
                <span class="quantity-current">
                  {{ comboProd.quantity }}
                </span>
              </div>
            </td>
            <td
              class="tbl-cellprice"
              v-else-if="!phase.is_temporary || !canEdit"
            >
              {{ comboProd.quantity }}
            </td>
            <td v-else class="tbl-cellinpt">
              <InputNumber
                class="inputintable"
                label="-"
                :value="comboProd.quantity"
                @input="onComboProductInput(comboProd._comboProductId, $event)"
                :state="isSaving ? 'disabled' : ''"
              />
            </td>
            <td class="tbl-cellprice">
              {{
                comboProd.picking && comboProd.quantity
                  ? (
                      (comboProd.price / comboProd.picking) *
                      comboProd.quantity
                    ).toFixed(2)
                  : '0.00'
              }}
            </td>

            <td
              class="col-delete"
              v-if="index === 0 && cIdx === 0 && phase.is_temporary && canEdit"
              :rowspan="totalRowsCount"
              @click="$emit('deleteStimulationType', sType.id)"
            >
              <div v-svg="{ name: 'delete' }"></div>
            </td>
          </tr>

          <tr
            v-if="item.products.length === 0"
            class="row tbl_row--active row--combination"
            :key="'combo-empty-' + item.id"
          >
            <td
              class="tbl-cellproblem"
              v-if="index === 0"
              :rowspan="totalRowsCount"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: 'info' }"></div>
                  <HoverTooltip
                    :header="sType.name"
                    :text="sType.description"
                  />
                </div>
                <div class="tbl_info-celltext">{{ sType.name }}</div>
              </div>
            </td>
            <td class="col-add tbl-cellproduct">
              <div class="tbl_info">
                <div class="tbl_info-wrap tooltip-trigger">
                  <div v-if="!phase.is_temporary" class="tbl_checkboxproduct">
                    <CheckBox
                      color-checked="accentfill"
                      color-un-checked="gray"
                      @input="onComboChange(item)"
                      :value="item.is_selected"
                      :style="{ pointerEvents: canEdit ? '' : 'none' }"
                    />
                  </div>
                  <HoverTooltip v-if="item.comment" :text="item.comment" />
                </div>
              </div>
            </td>
            <td class="tbl-cellproduct" colspan="2" style="text-align: center">
              {{ $t('DefenseCombinations:NoProducts') }}
            </td>
            <td class="tbl-cellprice">0.00</td>
            <td
              class="col-delete"
              v-if="index === 0 && phase.is_temporary && canEdit"
              :rowspan="totalRowsCount"
              @click="$emit('deleteStimulationType', sType.id)"
            >
              <div v-svg="{ name: 'delete' }"></div>
            </td>
          </tr>
        </template>
      </template>
    </template>

    <tr class="row tbl_row--active" v-if="displayItems.length === 0">
      <td class="tbl-cellproblem" rowspan="1">
        <div :class="phase.is_temporary ? 'cellproblem-inner' : ''">
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div v-svg="{ name: 'info' }"></div>
              <HoverTooltip :header="sType.name" :text="sType.description" />
            </div>
            <div class="tbl_info-celltext">{{ sType.name }}</div>
          </div>
          <Button
            v-if="phase.is_temporary && products.length >= 2 && canEdit"
            :text="$t('DefenseCombinations:Button')"
            size="h-micro"
            color="accentlines"
            icon="plus"
            @click="addCombination"
          />
        </div>
      </td>
      <td
        class="tbl-cellproduct"
        :colspan="phase.is_temporary && canEdit ? 5 : 4"
        style="text-align: center"
      >
        {{ $t('ProgramRowStimulationType:NoData') }}
      </td>
    </tr>

    <tr class="tablelinedecor">
      <td :colspan="phase.is_temporary && canEdit ? 6 : 5"></td>
    </tr>

    <DefenseAddProductModal
      v-if="showAddModal"
      :productsList="availableProductsToAdd"
      :alreadyAdded="alreadyAddedProductsIds"
      @save="addProduct"
      @close="
        showAddModal = false;
        activeCombinationId = null;
      "
    />

    <ModalSelectionConflict
      v-if="conflictModal.show"
      :productNames="conflictModal.productNames"
      :isCombination="conflictModal.isCombination"
      @confirm="onConflictConfirm"
      @cancel="onConflictCancel"
    />
  </tbody>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { mutationTypes } from '@/store/modules/programs';

import InputNumber from '@/components/views/wrappers/InputNumberWithCast';
import HoverTooltip from './HoverTooltip';
import HoverTooltipProduct from './HoverTooltipProduct';
import CheckBox from '@/components/CheckBox';
import Button from '@/components/views/Button';
import DefenseAddProductModal from './DefenseAddProductModal';
import ModalSelectionConflict from '@/components/modals/ModalSelectionConflict';
import AppInput from '@/components/views/Input.vue';

export default {
  name: 'ProgramRowStimulationType',
  props: {
    phase: { type: Object, required: true },
    sType: { type: Object, required: true },
  },
  components: {
    AppInput,
    Button,
    DefenseAddProductModal,
    ModalSelectionConflict,
    InputNumber,
    CheckBox,
    HoverTooltip,
    HoverTooltipProduct,
  },
  data() {
    return {
      editingProductId: null,
      editingValue: null,
      showAddModal: false,
      activeCombinationId: null,
      conflictModal: {
        show: false,
        productNames: [],
        isCombination: false,
        onConfirm: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'plantsCareProductsAsMap',
      'programSTypesProductsAsMap',
      'isProgramProductSelectionBlocked',
      'isProgramCombinationSelectionBlocked',
      'getProgramProductSelectionConflicts',
      'getProgramCombinationSelectionConflicts',
    ]),
    ...mapState({
      canEdit: (state) =>
        state.auth.currentUserRole?.claim_plants_care_add === 1,
      isSaving: (state) => state.programs.isSaving,
      programTypesStimulationProducts: (state) =>
        state.programs.programTypesStimulationProducts,
      products(state) {
        return state.programs.productsTypesStimulation
          .filter(
            ({ type_stimulation_id }) => type_stimulation_id === this.sType.id
          )
          .map(({ product_id }) => this.plantsCareProductsAsMap[product_id])
          .filter(Boolean)
          .filter(
            (product) =>
              product.is_active ||
              state.programs.programTypesStimulationProducts.some(
                (p) =>
                  p.product_id === product.id &&
                  this.getEffectiveQuantityByRecord(p) > 0 &&
                  (p.is_selected ||
                    state.programs.serverData.programTypesStimulationProducts.find(
                      ({ id }) => id === p.id
                    )?.is_selected)
              )
          );
      },
    }),
    productsAsMap() {
      const getValueById = (id) =>
        this.programSTypesProductsAsMap[
          `phase_${this.phase.id}_stype_${this.sType.id}_product_${id}`
        ] &&
        this.getEffectiveQuantityByRecord(
          this.programSTypesProductsAsMap[
            `phase_${this.phase.id}_stype_${this.sType.id}_product_${id}`
          ]
        );
      return Object.fromEntries(
        this.productsFiltered.map((p) => [p.id, getValueById(p.id) ?? ''])
      );
    },
    productsFiltered() {
      const products = this.programTypesStimulationProducts
        .filter(
          (p) =>
            p.type_stimulation_id === this.sType.id &&
            p.program_phase_id === this.phase.id
        )
        .map((p) => p.product_id);
      return this.products.filter((p) => products.includes(p.id));
    },
    combinations() {
      const combos =
        this.$store.state.programs.programTypesStimulationCombinations.filter(
          (c) =>
            c.program_phase_id === this.phase.id &&
            c.type_stimulation_id === this.sType.id
        );
      const comboProducts =
        this.$store.state.programs.programTypesStimulationCombinationsProducts;
      return combos
        .map((c) => ({
          type: 'combination',
          id: c.id,
          is_selected: c.is_selected,
          comment: c.comment,
          products: comboProducts
            .filter((p) => p.combination_id === c.id)
            .map((p) => ({
              ...p,
              ...(this.plantsCareProductsAsMap[p.product_id] || {}),
              _comboProductId: p.id,
              quantity: this.getEffectiveQuantityByRecord(p),
            })),
        }))
        .filter((combo) => this.shouldShowCombination(combo));
    },
    displayItems() {
      const items = [];
      this.productsFiltered.forEach((p) => {
        items.push({ type: 'product', data: p });
      });
      this.combinations.forEach((c) => {
        items.push(c);
      });
      return items;
    },
    totalRowsCount() {
      if (this.phase.is_temporary) {
        return (
          this.displayItems.reduce((acc, item, index) => {
            if (item.type === 'combination') {
              const rowsForProducts =
                item.products.length > 0 ? item.products.length : 1;
              const spacerRow = index > 0 ? 1 : 0;
              return acc + spacerRow + 1 + rowsForProducts;
            }
            return acc + 1;
          }, 0) || 1
        );
      }
      return (
        this.displayItems.reduce((acc, item) => {
          if (item.type === 'combination') return acc + item.products.length;
          return acc + 1;
        }, 0) || 1
      );
    },
    alreadyAddedProductsIds() {
      if (!this.activeCombinationId) return [];
      const combo = this.combinations.find(
        (c) => c.id === this.activeCombinationId
      );
      return combo ? combo.products.map((p) => p.product_id) : [];
    },
    availableProductsToAdd() {
      return this.products;
    },
    tempActiveProductCounts() {
      const counts = {};

      this.productsFiltered.forEach((product) => {
        const quantity = this.getEffectiveQuantityByRecord(
          this.getRowProduct(product)
        );
        if (quantity > 0) {
          counts[product.id] = (counts[product.id] || 0) + 1;
        }
      });

      this.combinations.forEach((combo) => {
        combo.products.forEach((product) => {
          const quantity = this.getEffectiveQuantityByRecord(
            this.getComboProductRecord(product._comboProductId)
          );
          if (quantity > 0) {
            counts[product.product_id] = (counts[product.product_id] || 0) + 1;
          }
        });
      });

      return counts;
    },
  },
  methods: {
    confirmDelete(message, next) {
      this.$confirm({
        message,
        buttons: {
          left: {
            text: this.$t('DefenseCombinations:ConfirmDelete'),
            icon: 'delete',
          },
          right: {
            text: this.$t('DefenseCombinations:ConfirmCancel'),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) next();
        },
      });
    },
    showConflictModal(productIds, isCombination, onConfirm) {
      this.conflictModal = {
        show: true,
        productNames: this.getSelectionConflictNames(productIds),
        isCombination,
        onConfirm,
      };
    },
    onConflictConfirm() {
      const callback = this.conflictModal.onConfirm;
      this.onConflictCancel();
      if (callback) callback();
    },
    onConflictCancel() {
      this.conflictModal = {
        show: false,
        productNames: [],
        isCombination: false,
        onConfirm: null,
      };
    },
    openComboAddModal(id) {
      this.activeCombinationId = id;
      this.showAddModal = true;
    },
    addCombination() {
      this.$store.commit(mutationTypes.addStimulationCombination, {
        program_phase_id: this.phase.id,
        type_stimulation_id: this.sType.id,
      });
    },
    removeCombination(id) {
      const combo = this.combinations.find((c) => c.id === id);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removeStimulationCombination, { id });

      if ((combo?.products?.length ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteCombination'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    removeComboProduct(comboProductId) {
      const comboProduct = this.combinations
        .flatMap((c) => c.products || [])
        .find((p) => p._comboProductId === comboProductId);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removeStimulationCombinationProduct, {
          id: comboProductId,
        });

      if (this.getEffectiveQuantityByRecord(comboProduct) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteProduct'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    addProduct(productId) {
      if (!this.activeCombinationId) return;
      this.$store.commit(mutationTypes.addStimulationCombinationProduct, {
        combination_id: this.activeCombinationId,
        product_id: productId,
      });
      this.activeCombinationId = null;
      this.showAddModal = false;
    },
    getEffectiveQuantityByRecord(record) {
      return record?.current_quantity ?? record?.quantity ?? 0;
    },
    getRowProduct(product) {
      return this.programTypesStimulationProducts.find(
        (p) =>
          p.type_stimulation_id === this.sType.id &&
          p.product_id === product.id &&
          p.program_phase_id === this.phase.id
      );
    },
    getEffectiveQuantity(product) {
      return this.getEffectiveQuantityByRecord(this.getRowProduct(product));
    },
    getSelectionConflictNames(productIds) {
      return [...new Set(productIds)]
        .map((id) => this.plantsCareProductsAsMap[id]?.name)
        .filter(Boolean);
    },
    replaceSelectionWithProduct(product, conflicts) {
      conflicts.combinationIds.forEach((id) => {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id,
          forStimulationType: true,
        });
      });
      conflicts.productIds.forEach((productId) => {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: productId,
          object_id: this.sType.id,
          program_phase_id: this.phase.id,
          forStimulationType: true,
        });
      });
      this.$store.commit(mutationTypes.setSelectedProduct, {
        product_id: product.id,
        object_id: this.sType.id,
        program_phase_id: this.phase.id,
        forStimulationType: true,
      });
    },
    replaceSelectionWithCombination(combo, conflicts) {
      conflicts.combinationIds.forEach((id) => {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id,
          forStimulationType: true,
        });
      });
      conflicts.productIds.forEach((productId) => {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: productId,
          object_id: this.sType.id,
          program_phase_id: this.phase.id,
          forStimulationType: true,
        });
      });
      this.$store.commit(mutationTypes.setSelectedCombination, {
        id: combo.id,
        forStimulationType: true,
      });
    },
    isTempProductPristine(product) {
      const rowProduct = this.getRowProduct(product);
      return (
        this.phase.is_temporary &&
        rowProduct &&
        rowProduct.quantity === null &&
        rowProduct.current_quantity === null
      );
    },
    getTempProductDisplayValue(product) {
      return this.isTempProductPristine(product)
        ? null
        : this.productsAsMap[product.id];
    },
    isTempProductQuantityBlocked(product) {
      if (!this.phase.is_temporary) return false;
      const rowProduct = this.getRowProduct(product);
      const currentQuantity = this.getEffectiveQuantityByRecord(rowProduct);
      if (currentQuantity > 0) return false;

      return Boolean(this.tempActiveProductCounts[product.id]);
    },
    isTempComboProductQuantityBlocked(comboProd) {
      if (!this.phase.is_temporary) return false;
      const currentQuantity = this.getEffectiveQuantityByRecord(
        this.getComboProductRecord(comboProd._comboProductId)
      );
      if (currentQuantity > 0) return false;

      return Boolean(this.tempActiveProductCounts[comboProd.product_id]);
    },
    getTempProductInputState(product) {
      if (this.isSaving) return 'disabled';
      if (!this.canEdit) return 'disabled2';
      return this.isTempProductQuantityBlocked(product) ? 'disabled' : '';
    },
    getTempComboProductInputState(comboProd) {
      if (this.isSaving) return 'disabled';
      if (!this.canEdit) return 'disabled2';
      return this.isTempComboProductQuantityBlocked(comboProd)
        ? 'disabled'
        : '';
    },
    getComboProductRecord(comboProductId) {
      return this.$store.state.programs.programTypesStimulationCombinationsProducts.find(
        (p) => p.id === comboProductId
      );
    },
    isTempComboProductPristine(comboProd) {
      const comboProduct = this.getComboProductRecord(
        comboProd._comboProductId
      );
      return (
        this.phase.is_temporary &&
        comboProduct &&
        comboProduct.quantity === null &&
        comboProduct.current_quantity === null
      );
    },
    getTempComboProductDisplayValue(comboProd) {
      return this.isTempComboProductPristine(comboProd)
        ? null
        : comboProd.quantity;
    },
    wasCombinationSelectedOnServer(comboId) {
      return Boolean(
        this.$store.state.programs.serverData.programTypesStimulationCombinations?.find(
          ({ id }) => id === comboId
        )?.is_selected
      );
    },
    shouldShowCombination(combo) {
      const hasInactiveProduct = combo.products.some(
        (product) => product.is_active === 0
      );
      if (!hasInactiveProduct) return true;
      return combo.is_selected || this.wasCombinationSelectedOnServer(combo.id);
    },
    getComboEffectiveQuantity(comboProductId) {
      return this.getEffectiveQuantityByRecord(
        this.getComboProductRecord(comboProductId)
      );
    },
    getComboTemplateQuantity(comboProductId) {
      return this.getComboProductRecord(comboProductId)?.quantity ?? '';
    },
    getTemplateQuantity(product) {
      return this.getRowProduct(product)?.quantity ?? '';
    },
    hasQuantityOverride(product) {
      const rowProduct = this.getRowProduct(product);
      if (!rowProduct) return false;
      return (
        rowProduct.current_quantity !== null &&
        rowProduct.current_quantity !== undefined &&
        rowProduct.current_quantity !== rowProduct.quantity
      );
    },
    hasComboQuantityOverride(comboProductId) {
      const comboProduct = this.getComboProductRecord(comboProductId);
      if (!comboProduct) return false;
      return (
        comboProduct.current_quantity !== null &&
        comboProduct.current_quantity !== undefined &&
        comboProduct.current_quantity !== comboProduct.quantity
      );
    },
    isEditing(product) {
      return this.editingProductId === product.id;
    },
    isEditingCombo(comboProductId) {
      return this.editingProductId === `combo_${comboProductId}`;
    },
    startEditing(product) {
      if (!this.canEdit || this.phase.is_temporary || this.isSaving) return;
      this.editingProductId = product.id;
      this.editingValue = this.getEffectiveQuantity(product);
      this.addEditingKeyListener();
      this.$nextTick(() => {
        this.focusEditInput(product.id);
      });
    },
    startEditingCombo(comboProductId) {
      if (!this.canEdit || this.phase.is_temporary || this.isSaving) return;
      this.editingProductId = `combo_${comboProductId}`;
      this.editingValue = this.getComboEffectiveQuantity(comboProductId);
      this.addEditingKeyListener();
      this.$nextTick(() => {
        this.focusEditInput(`combo_${comboProductId}`);
      });
    },
    focusEditInput(productId) {
      window.requestAnimationFrame(() => {
        const editInputRef = this.$refs[`editInput_${productId}`];
        const editInput = Array.isArray(editInputRef)
          ? editInputRef[0]
          : editInputRef;
        const inputEl =
          editInput?.$el?.querySelector('input') ||
          editInput?.querySelector?.('input');

        inputEl?.focus();
        const valueLength = inputEl?.value?.length ?? 0;
        inputEl?.setSelectionRange?.(valueLength, valueLength);
      });
    },
    onEditInput(value) {
      this.editingValue = value;
    },
    confirmEditing(product) {
      if (!this.isEditing(product)) return;
      const rowProduct = this.getRowProduct(product);
      if (!rowProduct) return;
      const parsedValue =
        this.editingValue === '' || this.editingValue === null
          ? null
          : Number(this.editingValue);
      if (Number.isNaN(parsedValue)) return;
      const templateQuantity = rowProduct.quantity ?? null;
      const currentQuantity =
        parsedValue === null || parsedValue === templateQuantity
          ? null
          : parsedValue;
      this.$store.commit(mutationTypes.setStimulationTypeProductQuantity, {
        program_phase_id: this.phase.id,
        type_stimulation_id: this.sType.id,
        product_id: product.id,
        current_quantity: currentQuantity,
      });
      this.cancelEditing();
    },
    confirmComboEditing(comboProductId) {
      if (!this.isEditingCombo(comboProductId)) return;
      const comboProduct = this.getComboProductRecord(comboProductId);
      if (!comboProduct) return;
      const parsedValue =
        this.editingValue === '' || this.editingValue === null
          ? null
          : Number(this.editingValue);
      if (Number.isNaN(parsedValue)) return;
      const templateQuantity = comboProduct.quantity ?? null;
      const currentQuantity =
        parsedValue === null || parsedValue === templateQuantity
          ? null
          : parsedValue;
      this.$store.commit(
        mutationTypes.setStimulationCombinationProductQuantity,
        {
          id: comboProductId,
          current_quantity: currentQuantity,
        }
      );
      this.cancelEditing();
    },
    cancelEditing() {
      this.removeEditingKeyListener();
      this.editingProductId = null;
      this.editingValue = null;
    },
    addEditingKeyListener() {
      window.addEventListener('keydown', this.onEditingKeydown, true);
      document.addEventListener('pointerdown', this.onEditingPointerdown, true);
    },
    removeEditingKeyListener() {
      window.removeEventListener('keydown', this.onEditingKeydown, true);
      document.removeEventListener(
        'pointerdown',
        this.onEditingPointerdown,
        true
      );
    },
    onEditingKeydown(event) {
      if (this.editingProductId === null) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      this.cancelEditing();
    },
    onEditingPointerdown(event) {
      if (this.editingProductId === null) return;

      const containerRef = this.$refs[`editContainer_${this.editingProductId}`];
      const container = Array.isArray(containerRef)
        ? containerRef[0]
        : containerRef;

      if (container?.contains(event.target)) return;

      this.cancelEditing();
    },
    onInput(product, value) {
      if (this.isTempProductQuantityBlocked(product)) return;
      this.$store.commit(mutationTypes.setStimulationTypeProductQuantity, {
        program_phase_id: this.phase.id,
        type_stimulation_id: this.sType.id,
        product_id: product.id,
        quantity: value,
      });
    },
    onChange(product) {
      if (this.phase.is_temporary) return;
      if (this.getSelectedState(product)) {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: product.id,
          object_id: this.sType.id,
          program_phase_id: this.phase.id,
          forStimulationType: true,
        });
        return;
      }
      const conflicts = this.getProgramProductSelectionConflicts({
        product_id: product.id,
        object_id: this.sType.id,
        program_phase_id: this.phase.id,
        forStimulationType: true,
      });
      if (conflicts.productIds.length || conflicts.combinationIds.length) {
        this.showConflictModal(conflicts.conflictedProductIds, false, () =>
          this.replaceSelectionWithProduct(product, conflicts)
        );
        return;
      }
      this.$store.commit(mutationTypes.setSelectedProduct, {
        product_id: product.id,
        object_id: this.sType.id,
        program_phase_id: this.phase.id,
        forStimulationType: true,
      });
    },
    onComboChange(combo) {
      if (this.phase.is_temporary) return;
      if (combo.is_selected) {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id: combo.id,
          forStimulationType: true,
        });
        return;
      }
      const conflicts = this.getProgramCombinationSelectionConflicts({
        id: combo.id,
        object_id: this.sType.id,
        program_phase_id: this.phase.id,
        forStimulationType: true,
      });
      if (conflicts.productIds.length || conflicts.combinationIds.length) {
        this.showConflictModal(conflicts.conflictedProductIds, true, () =>
          this.replaceSelectionWithCombination(combo, conflicts)
        );
        return;
      }
      this.$store.commit(mutationTypes.setSelectedCombination, {
        id: combo.id,
        forStimulationType: true,
      });
    },
    onComboProductInput(comboProductId, value) {
      const comboProduct = this.combinations
        .flatMap((combo) => combo.products)
        .find((product) => product._comboProductId === comboProductId);
      if (
        comboProduct &&
        this.isTempComboProductQuantityBlocked(comboProduct)
      ) {
        return;
      }
      this.$store.commit(
        mutationTypes.setStimulationCombinationProductQuantity,
        {
          id: comboProductId,
          quantity: value,
        }
      );
    },
    updateComboComment(id, comment) {
      this.$store.commit(mutationTypes.updateStimulationCombinationComment, {
        id,
        comment,
      });
    },
    calcProductNameStyle(product, isCombo = false, comboSelected = false) {
      const style = {};
      const selected = isCombo ? comboSelected : this.getSelectedState(product);
      style.cursor = this.phase.is_temporary ? 'auto' : 'pointer';
      if (!selected) style.color = '#a8a9ad';
      if (!this.canEdit) style.pointerEvents = 'none';
      return style;
    },
    getSelectedState(product) {
      return this.getRowProduct(product)?.is_selected ?? 0;
    },
    isProductSelectionDisabled(product) {
      return (
        !this.getSelectedState(product) &&
        this.isProgramProductSelectionBlocked({
          product_id: product.id,
          object_id: this.sType.id,
          program_phase_id: this.phase.id,
          forStimulationType: true,
        })
      );
    },
    isCombinationSelectionDisabled(combo) {
      return (
        !combo.is_selected &&
        this.isProgramCombinationSelectionBlocked({
          id: combo.id,
          object_id: this.sType.id,
          program_phase_id: this.phase.id,
          forStimulationType: true,
        })
      );
    },
  },
  beforeDestroy() {
    this.removeEditingKeyListener();
  },
};
</script>

<style scoped lang="scss">
@import '~@/scss/vars.scss';

#force-red {
  height: 24px;
  width: 24px;
  min-width: 24px;
  padding: 1px;

  & svg {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 1800px) {
  #force-red {
    height: 24px * $k1600;
    width: 24px * $k1600;
    min-width: 24px * $k1600;
  }
}

@media screen and (max-width: 1420px) {
  #force-red {
    height: 24px * $k1360;
    width: 24px * $k1360;
    min-width: 24px * $k1360;
  }
}

.quantity-old {
  font-size: 12px;
  color: $colorGray;
}

.quantity-display {
  text-align: right;
  padding: 0 6px;
}

.quantity-display--override {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.quantity-current {
  margin-left: auto;
  padding-right: 2px;
}

.tbl-cellinpt {
  padding: 0 !important;
}

.quantity-editor {
  position: relative;
  width: 100%;
  padding: 0 6px;
  box-sizing: border-box;
}

.quantity-editor__input {
  width: 100% !important;
  padding: 0 !important;
  box-sizing: border-box;
}

.quantity-editor__input :deep(.inptwrap) {
  width: 100% !important;
  padding: 0 !important;
}

.quantity-editor__input :deep(.inpt) {
  text-align: left;
  padding: 0 30px 0 6px !important;
}

.quantity-editor__submit {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  z-index: 99999;
  cursor: pointer;
  margin: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.quantity-editor__submit :deep(svg) {
  width: 20px;
  height: 20px;
}

.cellproblem-inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.row--combination-spacer {
  height: 12px;
  padding: 0;
  border: none;
}

.combination-header-cell {
  padding-left: 0;

  label {
    display: none;
  }

  .tbl_info {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .tbl_info-wrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex: 1 1 auto;
  }

  .inputintable {
    flex-grow: 1 !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding: 4px !important;
    box-sizing: border-box;
    min-width: auto;
  }
}

.combination-header-delete {
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}

.combination-inline-delete {
  margin-left: auto;
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.quantity-editor__submit :deep(.svgfill) {
  fill: #67a53a;
}

.temp-input--pristine {
  opacity: 0.58;
}

.temp-input--pristine :deep(.inpt) {
  color: #a8a9ad;
}

.temp-input--pristine :deep(.inptwrap) {
  background: rgba(237, 242, 228, 0.42);
}
</style>

<style lang="scss">
.quantity-editor__input .inptwrap {
  width: 100% !important;
  padding: 0 !important;
}

.quantity-editor__input .inpt {
  text-align: left;
  padding: 0 30px 0 6px !important;
}

.quantity-editor__submit .svgfill {
  fill: #67a53a;
}

.quantity-editor__submit .svg-icon {
  width: 20px;
  height: 20px;
}

.combination-header-delete .vsvg-auto,
.combination-header-delete .svg-icon,
.combination-inline-delete .vsvg-auto,
.combination-inline-delete .svg-icon {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
}
</style>
